// Group the data by field, if given
export const groupDataByField = <T>(t: any, data: T[], groupByField: keyof T | undefined): Record<string, T[]> => {

    // If the property is not given, don't group the data
    if (!groupByField) {
        return { ungrouped: data };
    }
        
    // Group the data on the given field
    return data.reduce((groups, item) => {
        const key = item[groupByField] as string | undefined;

        // Use group key or other for empty values
        const groupKey = key || t('general.other');

        if (!groups[groupKey]) groups[groupKey] = [];
        groups[groupKey].push(item);
        return groups;
    }, {} as Record<string, T[]>);
};